import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { NotificationProfile } from './NotificationProfile'

import { useSettingsStore } from '../../../common'

export const BudgetNotificationProfiles = observer(() => {
  const { budgetProfiles } = useSettingsStore()

  return (
    <Stack>
      {budgetProfiles.map((profile) => (
        <NotificationProfile key={profile.guid} profile={profile} />
      ))}
    </Stack>
  )
})
